import { Component } from 'react';
import PropTypes from 'prop-types';
import { Control, Errors, actions } from 'forms/rrf';
import { FormGroup, FormLabel, FormControl } from 'react-bootstrap';
import _ from 'lodash';
import { validators } from '../../../../utils/validators';


class Select extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  renderOptions = (values, selectedValue) => {
    const { valueAttr, labelAttr } = this.props;

    if (_.isPlainObject(values)) {
      return (
        Object.keys(values).map(item => (<option key={item} value={item} selected={selectedValue === item}>{values[item]}</option>))
      );
    }

    return (
      values.map((item) => {
        if (_.isPlainObject(item)) {
          return (
            <option
              key={_.get(item, valueAttr)}
              value={_.get(item, valueAttr)}
              selected={selectedValue === _.get(item, valueAttr)}
            >
              {_.get(item, labelAttr)}
            </option>
          );
        }
        return (<option key={item} value={item} selected={selectedValue === item}>{item}</option>);
      })
    );
  };

  changeAction = (model, value) => (dispatch) => {
    dispatch(actions.change(model, value));
    dispatch(actions.resetValidity(model));

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  };

  render() {
    const {
      model, values, hasEmptyValue, label, controlId, errorLabel, required, emptyValueDisabled, emptyValue,
      selectedValue
    } = this.props;

    return (
      <FormGroup controlId={controlId} className={`form-group${this.state[errorLabel] ? ` has-${this.state[errorLabel]}` : ''}`}>
        {label && <FormLabel>{label}{required ? '*' : ''}</FormLabel>}
        <Control.select
          model={model}
          validators={required ? {required: validators.required(this.updateErrors, errorLabel)} : {}}
          as="select"
          defaultValue={selectedValue}
          controlProps={{
            disabled: !!this.props.disabled
          }}
          component={FormControl}
          changeAction={this.changeAction}
        >
          { hasEmptyValue && <option value="" disabled={emptyValueDisabled} selected={selectedValue === ''}>{emptyValue}</option>}
          {
            values && this.renderOptions(values, selectedValue)
          }
        </Control.select>

        {required && (
          <Errors
            show={{touched: true, focus: false}}
            className="errors"
            model={model}
            messages={{required: 'This field is required'}}
          />
        )}
      </FormGroup>
    );
  }
}

Select.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  values: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr: PropTypes.string,
  valueAttr: PropTypes.string,
  disabled: PropTypes.bool,
  hasEmptyValue: PropTypes.bool,
  emptyValueDisabled: PropTypes.bool,
  emptyValue: PropTypes.string,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
  required: PropTypes.bool,
  selectedValue: PropTypes.string,
};

Select.defaultProps = {
  hasEmptyValue: true,
  emptyValueDisabled: true,
  emptyValue: 'Select one...',
  labelAttr: 'label',
  valueAttr: 'value',
  disabled: false,
  controlId: Math.random().toString(16).substring(2),
  errorLabel: 'error',
  required: false,
};

export default Select;
